<!-- 资源管理-视频管理-视频列表-详情/审核-弹窗模式-吴影茹 -->
<template>
  <OyModal
    v-model:open="modalVisible"
    :title="'视频' + (type == 'check' ? '审核' : '详情')"
    :width="1000"
    @cancel="cancelHandler"
    :customFooter="true"
  >
    <DetailContent :id="id" :type="type" @submit="cancelHandler" />
    <template #footer>
      <a-button @click="cancelHandler">关 闭</a-button>
    </template>
  </OyModal>
</template>
              
  <script setup lang="ts">
import { onMounted, ref, PropType, nextTick, watch } from 'vue'
import DetailContent from './DetailContent.vue'

const props = defineProps({
  visible: {
    type: Boolean,
    default: false
  },
  id: {
    type: String,
    default: ''
  },
  //   detail普通详情  check审核   rejectDetail拒绝详情   previewDetail预览详情
  type: {
    type: String,
    default: 'detail'
  }
})

onMounted(() => {})
const emit = defineEmits(['update:visible'])

const modalVisible = ref<boolean>(false)

watch(
  () => props.visible,
  (newVal) => {
    modalVisible.value = newVal
  },
  { immediate: true }
)

// 关闭
const cancelHandler = () => {
  emit('update:visible', false)
}
</script>
              
<style lang="scss" scoped>
</style>